import { UnknownAction } from 'redux'
import { RootState } from './store'
import { ThunkAction } from 'redux-thunk'
import { changeLayerList, setLineTypes } from './tool'
import { findUniquesLayers, findUniquesLineTypes, ImportGeometricShape, processParsedJSONProjectInformation, processParsedJSONToShapes } from '../plan_file_handling/import_file/importGeometricShape'
import { init } from './model'
import { fitToScreen } from './interface'
import { createSaveData } from '../plan_file_handling/export_file/exportGeometricShape'
import { PostOptions } from '../plan_file_handling/export_file/postData'
import { setSending } from './interaction'
import { GlobalImageRepository } from '../components/Editor/shapes/GlobalImageRepository'

export type AppThunk<ReturnType = void, ExtraArg = unknown> = ThunkAction<
  ReturnType,
  RootState,
  ExtraArg,
  UnknownAction
>
interface ReadProjectResult {
  shapes: GeometricShape[],
  projectInformation: any,
  uniqueLineTypes: LineType[],
  uniqueLayers?: Layer[],
}
export const PostPlanData = (URL: string, options: RequestInit, dataInfo: PostOptions): AppThunk => async (dispatch, getState) => {
  const data = getFormattedPlanData(getState)
  const input = { ...options, body: JSON.stringify({ ...dataInfo, content: data }) }
  const response = await fetch(URL ?? "", input)
  if (!response.ok) {
    console.log(response);
    throw new Error('Network response was not ok');
  } else (
    dispatch(setSending(false))
  )
}
export const sendParentPostMessage = (message: string, target: string): AppThunk => (dispatch, getState) => {
  dispatch(setSending(true));
  const data = getFormattedPlanData(getState)
  window.parent.postMessage({ command: message, payload: data }, target);
  dispatch(setSending(false));
}

export const SavePlanData =
  (): AppThunk => async (dispatch, getState) => {
    console.log("saving...");

    const data = getFormattedPlanData(getState)
    const json: string = JSON.stringify(data, null, 2);
    const myblob = new Blob([json]);
    const saveFile = document.createElement("a");
    saveFile.href = URL.createObjectURL(myblob);
    saveFile.download = "2d-editor_save.json";
    saveFile.click();
    setTimeout(() => URL.revokeObjectURL(saveFile.href), 60000);
  }

function getFormattedPlanData(getState: () => RootState) {
  return createSaveData(
    getState().model.present.model,
    getState().tool.lineTypes,
    getState().tool.layerList);
}

export type LoadOption = "fitToScreen" | undefined
export const LoadJSONData =
  (JSONPlanData: any, args?: LoadOption[]): AppThunk<void, LoadOption[] | undefined> =>
    async (dispatch, getState) => {
      const result = processFile(JSONPlanData.payload as ImportGeometricShape[]);
      loadJson(dispatch, getState, result);
      handleLoadOptions(dispatch, getState, args)

    }


export const LoadPlanData =
  (files: FileList, args?: LoadOption[]): AppThunk<void, LoadOption[] | undefined> =>
    async (dispatch, getState) => {

      const projectFileReadResult = await handleFile(files);
      if (projectFileReadResult) {
        for (const shape of projectFileReadResult.shapes) {
          if (shape.type === "symbol" && shape.url) {
            console.log("adding image: ", shape.url);
            await GlobalImageRepository.addImageFromUrl(shape.url, shape.url, {
              persistAsDataUrl: true,
              crossOrigin: "anonymous", // recommend for CORS
              // Optionally override fetch credentials (defaults inferred from crossOrigin)
              // fetchCredentials: "include",
            });
            shape.imageKey = shape.url;
            //todo: expect radian also why -rot
            shape.rot = -shape.rot / 180 * Math.PI;
          }
        };
      }
      loadJson(dispatch, getState, projectFileReadResult);
      handleLoadOptions(dispatch, getState, args)


    }
const handleLoadOptions: AppThunk<void, LoadOption[] | undefined> = (dispatch, getState, args) => {
  if (args?.find(a => a === 'fitToScreen')) {
    dispatch(fitToScreen(getState().model.present.boundingbox))
  }
}

const loadJson: AppThunk = (dispatch, getState, planData: any) => {
  if (planData !== undefined) {
    console.log("beolvasott json:", planData);
    if (planData.uniqueLayers?.length) dispatch(changeLayerList(planData.uniqueLayers));
    dispatch(setLineTypes(planData.uniqueLineTypes));
    dispatch(
      init(
        {
          model: {
            shapes: planData.shapes,
            projectInformation: planData.projectInformation,
          }
        }
      ))
  }
}
async function handleFile(files: FileList): Promise<ReadProjectResult | undefined> {

  const reader = new FileReader();
  // Return a Promise that resolves once the file is read
  const fileReadResult = new Promise<ReadProjectResult | undefined>((resolve, reject) => {
    reader.onload = (evt: ProgressEvent<FileReader>) => {
      if (typeof evt.target?.result === "string") {
        try {
          const jsonContent = JSON.parse(evt.target.result);
          const result = processFile(jsonContent as ImportGeometricShape[]);
          resolve(result);  // Resolve the Promise with the processed result
        } catch (error) {
          let errorWithMessage: Error = (error instanceof Error) ? error : Error(String(error))
          reject(errorWithMessage)
        }
      }
    };

    reader.onerror = (error) => {
      let errorWithMessage: Error = (error instanceof Error) ? error : Error(String(error))
      reject(errorWithMessage)
    };

    reader.readAsText(files[0]);  // Begin reading the file
  });

  return fileReadResult;
};

function processFile(parsedData: ImportGeometricShape[]): ReadProjectResult {
  const uniqueLineTypes = findUniquesLineTypes(parsedData);
  //console.log(uniqueLineTypes, "lineTypes");

  const uniqueLayers = findUniquesLayers(parsedData)
  //console.log(uniqueLayers, "layer types");

  const shapes = processParsedJSONToShapes(parsedData, uniqueLineTypes);
  //console.log("ezittaz", shapes);
  const projectInfomation: any = processParsedJSONProjectInformation(parsedData);
  return {
    shapes: shapes,
    projectInformation: projectInfomation,
    uniqueLineTypes: uniqueLineTypes,
    uniqueLayers: uniqueLayers
  }
}

